import script from "./DashboardReferee.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardReferee.vue?vue&type=script&setup=true&lang=js"

import "./DashboardReferee.vue?vue&type=style&index=0&id=3bec4b99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bec4b99"]])

export default __exports__